<div class="gapfunding-upsell">
    <div class="gapfunding-upsell__header">Vil du også spille med i næste lodtrækning
        til {{ dibsSalesDate | date : "MMMM" }}?
    </div>

    <div class="gapfunding-upsell__content">
        <div class="gapfunding-upsell__countdown">
            <app-countdown-sale-stop
                    [showAllCountdownBlocks]="true"
                    [useAlternate]="true"
                    [showNextBSSaleStopDate]="false"
                    [makeFlex]="true"></app-countdown-sale-stop>
        </div>

        <button tabindex="0" class="cta cta--primary" (click)="onCtaClick()">
            Spil med i {{ dibsSalesDate | date: "MMMM" }} ({{ pricePrMonth | money }})
        </button>
    </div>

    <div class="gapfunding-upsell__bg">
        <app-woop-background></app-woop-background>
    </div>
</div>
